import { createAction, props } from '@ngrx/store';
import { RmsContractBalance } from '@cemex-core/cmx-api';

export const FETCH_AGREEMENTS = createAction(
  '[AGREEMENTS] Fetch Agreements',
  props<{ productCode: string; contractCode: string }>(),
);

export const FETCH_AGREEMENTS_SUCCESS = createAction(
  '[AGREEMENTS] Fetch Agreements Success',
  props<{ id: string; balance: RmsContractBalance[] }>(),
);

export const FETCH_AGREEMENTS_FAILURE = createAction('[AGREEMENTS] Fetch Agreements Failure', props<{ error: any }>());

export const UPDATE_AGREEMENT_BALANCE = createAction(
  '[AGREEMENTS] Update Agreement Balance',
  props<{ id: string; totalAmount: number }>(),
);

export const AGREEMENTS_ACTION = {
  FETCH_AGREEMENTS,
  FETCH_AGREEMENTS_SUCCESS,
  FETCH_AGREEMENTS_FAILURE,
  UPDATE_AGREEMENT_BALANCE,
};

export default AGREEMENTS_ACTION;
